/* JCR cart UX (2026-10-14)
 * 1. Auto-adds the free North Carolina State Reporting item once when the cart has a CE class and no reporting item.
 *    If the shopper removes it while a CE class is still in the cart, it is not added back this session.
 * 2. Phones: sticky "Total + Check out" bar on /cart whenever the main Check out button is off screen.
 * 3. NC CE ads page: "Register" adds by AJAX and opens the cart drawer. Without JS the forms still post to /cart/add.
 */
(function () {
  if (window.JCRCart) return;

  var NC_REPORTING_VARIANT = 52019533938969;
  var CE_TYPES = ['continuing education', 'ceshort'];
  var REP_TYPE = 'state reporting';
  var KEY_PREV = 'jcr_rep_prev';
  var KEY_DECLINED = 'jcr_rep_declined';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var memory = {};

  function store(key, value) {
    try {
      if (value === undefined) return window.sessionStorage.getItem(key);
      window.sessionStorage.setItem(key, value);
    } catch (e) {
      if (value === undefined) return memory[key] || null;
      memory[key] = value;
    }
    return null;
  }

  function request(path, body) {
    var options = body === undefined
      ? { headers: { Accept: 'application/json' }, cache: 'no-store' }
      : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) };
    return fetch(root + path, options).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || (data && (data.errors || data.status >= 400))) throw new Error((data && data.description) || 'Cart request failed');
        return data;
      });
    });
  }

  function cartState(cart) {
    var state = { ce: false, rep: false };
    (cart.items || []).forEach(function (item) {
      var type = String(item.product_type || '').toLowerCase();
      if (CE_TYPES.indexOf(type) !== -1) state.ce = true;
      if (type === REP_TYPE) state.rep = true;
    });
    return state;
  }

  /* Returns true when NC reporting should be added. Records a "declined" flag when the shopper removed it. */
  function needsReporting(cart, addingClass) {
    var now = cartState(cart);
    var prev = null;
    try { prev = JSON.parse(store(KEY_PREV) || 'null'); } catch (e) { prev = null; }
    if (prev && prev.ce && prev.rep && now.ce && !now.rep) store(KEY_DECLINED, '1');
    store(KEY_PREV, JSON.stringify(now));
    if (now.rep || !(now.ce || addingClass)) return false;
    return store(KEY_DECLINED) !== '1';
  }

  function markAdded() {
    store(KEY_PREV, JSON.stringify({ ce: true, rep: true }));
  }

  function sectionIds() {
    var ids = [];
    document.querySelectorAll('cart-page,cart-drawer').forEach(function (el) {
      if (el.dataset.sectionId && ids.indexOf(el.dataset.sectionId) === -1) ids.push(el.dataset.sectionId);
    });
    return ids.slice(0, 5);
  }

  function renderCarts(sections) {
    var ids = sectionIds();
    if (!ids.length) return Promise.resolve();
    var ready = sections && ids.every(function (id) { return sections[id]; })
      ? Promise.resolve(sections)
      : fetch(root + 'cart?sections=' + encodeURIComponent(ids.join(',')), { cache: 'no-store' }).then(function (r) {
          if (!r.ok) throw new Error('Cart refresh failed');
          return r.json();
        });
    return ready.then(function (data) {
      document.querySelectorAll('cart-page,cart-drawer').forEach(function (cart) {
        var html = data[cart.dataset.sectionId];
        if (!html) return;
        var node = new DOMParser().parseFromString(html, 'text/html');
        if (cart.matches('cart-drawer')) {
          cart.lastDrawerBody = cart.getTemplateContent(node);
          cart.mount();
          cart.emit('update-nodes', { node: cart.lastDrawerBody });
          cart.updateEmptyStatus();
        } else {
          holdScroll();
          cart.emit('update-nodes', { node: node });
          cart.updateEmptyStatus(!node.querySelector('cart-item'));
          cart.setCartState();
        }
      });
    });
  }

  /* The theme scrolls the cart page to the item list after an update. Skip that for our background add. */
  var nativeScrollIntoView = Element.prototype.scrollIntoView;
  var scrollTimer = null;
  function holdScroll() {
    Element.prototype.scrollIntoView = function () {
      if (this.closest && this.closest('cart-page')) return;
      return nativeScrollIntoView.apply(this, arguments);
    };
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function () { Element.prototype.scrollIntoView = nativeScrollIntoView; }, 1500);
  }

  /* ---------- 1. Auto-add NC reporting ---------- */
  var busy = false;
  var again = false;

  function ensureReporting() {
    if (busy) { again = true; return Promise.resolve(); }
    busy = true;
    return request('cart.js')
      .then(function (cart) {
        var extra = (cart.items || []).filter(function (item) { return item.variant_id === NC_REPORTING_VARIANT && item.quantity > 1; })[0];
        if (extra) {
          return request('cart/change.js', { id: extra.key, quantity: 1, sections: sectionIds(), sections_url: window.location.pathname })
            .then(function (data) { return renderCarts(data.sections); });
        }
        if (!needsReporting(cart, false)) return null;
        document.querySelectorAll('.jcr-cart-reporting-reminder').forEach(function (box) { box.classList.add('jcr-rep-hold'); });
        markAdded();
        return request('cart/add.js', { items: [{ id: NC_REPORTING_VARIANT, quantity: 1 }], sections: sectionIds(), sections_url: window.location.pathname })
          .then(function (data) { return renderCarts(data.sections); });
      })
      .catch(function () {
        document.querySelectorAll('.jcr-rep-hold').forEach(function (box) { box.classList.remove('jcr-rep-hold'); });
      })
      .then(function () {
        busy = false;
        if (again) { again = false; ensureReporting(); }
      });
  }

  function cartSignature(scope) {
    if (!scope) return '';
    return Array.prototype.map.call(scope.querySelectorAll('cart-item'), function (item) {
      return (item.dataset.jcrLineKey || item.dataset.variantId) + ':' + item.dataset.quantity;
    }).join('|');
  }

  var lastSignature = null;
  var timer = null;

  function activeCart() {
    var page = document.querySelector('cart-page');
    if (page) return page;
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.classList.contains('is-opened')) return drawer;
    return null;
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      var cart = activeCart();
      if (!cart) { lastSignature = null; return; }
      var signature = cartSignature(cart);
      if (!signature || signature === lastSignature) return;
      lastSignature = signature;
      ensureReporting();
    }, 250);
  }

  /* ---------- 2. Sticky checkout bar on /cart (phones) ---------- */
  function stickyCheckout() {
    var page = document.querySelector('cart-page');
    if (!page || !('IntersectionObserver' in window)) return;
    var phone = window.matchMedia('(max-width: 749px), (max-height: 500px)');
    var bar = document.createElement('div');
    bar.className = 'jcr-co-bar';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="jcr-co-bar__total"><span class="jcr-co-bar__label">Total</span><span class="jcr-co-bar__amount"></span></div>' +
      '<button type="button" class="btn btn--primary btn--lg jcr-co-bar__button" tabindex="-1">Check out</button>';
    document.body.appendChild(bar);
    var amount = bar.querySelector('.jcr-co-bar__amount');
    var button = bar.querySelector('.jcr-co-bar__button');
    var watched = null;
    var mainVisible = true;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { if (entry.target === watched) mainVisible = entry.intersectionRatio >= 0.95; });
      update();
    }, { threshold: [0, 0.95, 1] });

    function mainButton() {
      return page.querySelector('[data-cart-page-checkout-button]');
    }

    function update() {
      var main = mainButton();
      if (main !== watched) {
        if (watched) observer.unobserve(watched);
        watched = main;
        if (main) { mainVisible = true; observer.observe(main); }
      }
      var total = page.querySelector('.cart-subtotal__totals-price');
      amount.textContent = total ? total.textContent.replace(/\s+/g, ' ').trim() : '';
      var on = phone.matches && !!main && !main.disabled && !mainVisible && !page.hasAttribute('is-empty');
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      button.tabIndex = on ? 0 : -1;
      document.body.classList.toggle('jcr-co-bar-on', on);
    }

    button.addEventListener('click', function () {
      var main = mainButton();
      if (main) main.click();
    });
    if (phone.addEventListener) phone.addEventListener('change', update);
    new MutationObserver(update).observe(page, { childList: true, subtree: true, characterData: true });
    update();
  }

  /* ---------- 3. NC CE ads page: Register by AJAX ---------- */
  function registerHandler(event) {
    var form = event.target;
    if (event.defaultPrevented || !(form instanceof HTMLFormElement) || !form.closest('.jncce-products')) return;
    if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.purchaseHandler !== 'function' || !window.fetch || !window.DOMParser) return;
    event.preventDefault();
    if (form.dataset.jcrBusy === '1') return;
    form.dataset.jcrBusy = '1';
    var button = form.querySelector('[type="submit"]');
    var label = button ? button.textContent : '';
    if (button) { button.disabled = true; button.textContent = 'Adding…'; }
    var id = Number((form.querySelector('[name="id"]') || {}).value);
    var quantity = Number((form.querySelector('[name="quantity"]') || {}).value || 1);
    var added = false;

    request('cart.js')
      .then(function (cart) {
        var items = [{ id: id, quantity: quantity }];
        if (needsReporting(cart, true)) { items.push({ id: NC_REPORTING_VARIANT, quantity: 1 }); markAdded(); }
        return request('cart/add.js', { items: items, sections: sectionIds(), sections_url: window.location.pathname });
      })
      .then(function (data) {
        added = true;
        var html = data.sections && data.sections[drawer.dataset.sectionId];
        if (!html) throw new Error('Drawer refresh failed');
        lastSignature = null;
        return drawer.purchaseHandler(new DOMParser().parseFromString(html, 'text/html'), data.items && data.items[0]);
      })
      .catch(function () {
        if (added) window.location.assign(root + 'cart');
        else HTMLFormElement.prototype.submit.call(form);
      })
      .then(function () {
        delete form.dataset.jcrBusy;
        if (button) { button.disabled = false; button.textContent = label; }
      });
  }

  function start() {
    stickyCheckout();
    schedule();
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var target = records[i].target;
        if (target.closest && target.closest('cart-page,cart-drawer')) { schedule(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
    var drawer = document.querySelector('cart-drawer');
    if (drawer) new MutationObserver(schedule).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  document.addEventListener('submit', registerHandler);
  window.JCRCart = { ensureReporting: ensureReporting, renderCarts: renderCarts };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
